import { createContext } from 'react';
import { FCProps } from 'types/FCProps';

import { IPopularReportsDataCtx, IReportsDataCtx } from './types';
import { reportsInitialValues } from './utils';

import useReportingContent from 'hooks/useReportingContent';
import usePopularReportContent from 'hooks/usePopularReportContent';

export const ReportsContext = createContext<IReportsDataCtx>(reportsInitialValues);

const ReportsProvider = ({ children }: FCProps): JSX.Element => {
  const {
    fetching,
    fetchingUsers,
    fetchingFilters,
    reports,
    users,
    activeFilters,
    setActiveFilters,
    getReports,
    refreshReports,
    getReportCreators,
    fetchingReportCreators,
    reportCreators,
    generateNewReport,
    getReportsFilteringPreferences,
    saveReportsFiltersPreferences,
    getUsers,
    error,
  } = useReportingContent();

  return (
    <ReportsContext.Provider
      value={{
        fetching,
        fetchingUsers,
        fetchingFilters,
        reports,
        users,
        activeFilters,
        setActiveFilters,
        getReports,
        refreshReports,
        getReportCreators,
        fetchingReportCreators,
        reportCreators,
        generateNewReport,
        getReportsFilteringPreferences,
        saveReportsFiltersPreferences,
        getUsers,
        error,
      }}
    >
      {children}
    </ReportsContext.Provider>
  );
};

export const PopularReportsContext = createContext<IPopularReportsDataCtx>({});

export const PopularReportsProvider = ({ children }: FCProps): JSX.Element => {
  const { getUsers, users } = useReportingContent();

  const {
    fetchingPopularReports,
    updatingPopularReport,
    popularReports,
    generatePopularReport,
    schedulePopularReport,
    buildPopularReportDetails,
  } = usePopularReportContent();

  return (
    <PopularReportsContext.Provider
      value={{
        getUsers,
        generatePopularReport,
        schedulePopularReport,
        users,
        popularReports,
        fetchingPopularReports,
        updatingPopularReport,
        buildPopularReportDetails,
      }}
    >
      {children}
    </PopularReportsContext.Provider>
  );
};

export default ReportsProvider;
